import { customElement, property } from 'lit/decorators.js';
import { localized } from "@lit/localize";
import { UsosBox } from "./usos-box";
import commonStyle from './usos-box.scss';
import style from './success-box.scss';

/**
 * Success box information. Registers as alert for accessibility tools.
 */

@customElement('success-box')
@localized()
export class SuccessBox extends UsosBox {
    static override styles = [commonStyle, style];

    /** Predefined alert role. */
    @property({ reflect: true }) override role = 'alert';
}

declare global {
    interface HTMLElementTagNameMap {
        'success-box': SuccessBox
    }
}